export default "__VITE_ASSET__0979f427__"